import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { allocationsRoutes } from './routes';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';

/** One of a bill's (property, utility) pairs, as the AP push asks about it. */

/** What property-service answers for a pair: the property utility it is, among the rest of its context. */

export class Allocations {
  constructor() {
    _defineProperty(this, "routes", allocationsRoutes);
  }
  /**
   * The property utility each of a bill's (property, utility) pairs is: the question bill-automation asks
   * property-service when it pushes the bill, asked the same way so the bill details resolve an AP GL
   * account the way the push will (LB-5980). It needs `ManageProperty`, and a caller without it is refused.
   */
  async getApPushContext(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.apPushContext, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAddBillingCycle(data, options) {
    const allocationCycleId = data.allocationCycleId,
      propertyId = data.propertyId;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.addBillingCycles(propertyId), {
      allocationCycleId,
      propertyId
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllocationComparison(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.allocationComparison, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async getAllocationHistory(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.allocationHistory, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllocationPreview(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.allocationPreview, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }

  /**
   * What an allocation would look like for bill values that have not been saved. Read-only: no bill,
   * no allocation table and no charges are created, so it can be called again on every edit.
   */
  async postAllocationSuggestion(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.allocationSuggestion, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllocationsHistory(data, options) {
    const companyId = data.companyId;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.history(companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBillingCycles(data, options) {
    const allocationCycleId = data.allocationCycleId,
      propertyId = data.propertyId;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.billingCycles(propertyId), _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: {
        allocationCycleId
      }
    }));
    return resp.data;
  }
  async getBillingSummary(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.billingSummary, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBillsAllocations(data, options) {
    const allocationCycleId = data.allocationCycleId,
      propertyIds = data.propertyIds;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.billsAllocations, {
      allocationCycleId,
      propertyIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUtilityAllocationExport(data, options) {
    const _data$allocationCycle = data.allocationCycleId,
      allocationCycleId = _data$allocationCycle === void 0 ? null : _data$allocationCycle,
      _data$monthsBack = data.monthsBack,
      monthsBack = _data$monthsBack === void 0 ? 12 : _data$monthsBack,
      _data$propertyIds = data.propertyIds,
      propertyIds = _data$propertyIds === void 0 ? null : _data$propertyIds;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.utilityAllocationExport, {
      allocationCycleId,
      monthsBack,
      propertyIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** One cycle with history, or with fromMonth and toMonth every closed cycle in the range as CSV or XLSX. */
  async downloadUtilityAllocationExport(data, options) {
    const _data$allocationCycle2 = data.allocationCycleId,
      allocationCycleId = _data$allocationCycle2 === void 0 ? null : _data$allocationCycle2,
      _data$monthsBack2 = data.monthsBack,
      monthsBack = _data$monthsBack2 === void 0 ? 12 : _data$monthsBack2,
      _data$propertyIds2 = data.propertyIds,
      propertyIds = _data$propertyIds2 === void 0 ? null : _data$propertyIds2,
      fromMonth = data.fromMonth,
      toMonth = data.toMonth,
      _data$format = data.format,
      format = _data$format === void 0 ? 'csv' : _data$format;
    return requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.utilityAllocationExportDownload, {
      allocationCycleId,
      monthsBack,
      propertyIds,
      fromMonth,
      toMonth,
      format
    }, _objectSpread({
      responseType: 'blob'
    }, options.cancelToken));
  }

  /** A table from a Livy answer as an Excel file, built server-side with the same formula guard as every export. */
  async downloadTableXlsx(table) {
    return requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.tableExport, table, {
      responseType: 'blob'
    });
  }

  /** The caller's own scheduled reports, and whether this environment sends them. */
  async getScheduledReports() {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.scheduledReports);
    return resp.data;
  }

  /** Email the caller this report every month; the same request again re-enables it. */
  async createScheduledReport(schedule) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.scheduledReports, schedule);
    return resp.data;
  }
  async setScheduledReportEnabled(id, enabled) {
    await requestService(API_SERVICE_NAMES.ALLOCATIONS).patch(this.routes.scheduledReport(id), {
      enabled
    });
  }
  async deleteScheduledReport(id) {
    await requestService(API_SERVICE_NAMES.ALLOCATIONS).delete(this.routes.scheduledReport(id));
  }
  async getMonthlyReportSettings(options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.monthlyReportSettings, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async saveMonthlyReportSettings(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).put(this.routes.monthlyReportSettings, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async sendMonthlyReport(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.monthlyReportSend, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCurrentCycle(data, options) {
    const companyId = data.companyId;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.currentCycle(companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postBillCreated(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.fileAttached, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putBillUpdated(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).put(this.routes.fileAttached, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllocationTableAggregate(data, options) {
    const resp = await requestService('aggregate').get(this.routes.allocationTableAggregate, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async getAllocationTableInfo(data, options) {
    const billingCycleIds = data.billingCycleIds;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.allocationTableInfo, {
      billingCycleIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBillsFileCabinet(data, options) {
    const propertyIds = data.propertyIds;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.billsFileCabinet, {
      propertyIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /**
   * Removes an allocation (LB-5953): property-service archives its bill, never wipes it, and refuses one already
   * billed to residents. The uploaded bill it was made from, if any, stays on file, no longer allocated.
   */
  async removeBill(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).delete(this.routes.removeBill(data.billId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteBillingCycle(data, options) {
    const billingCycleId = data.billingCycleId,
      propertyId = data.propertyId;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).delete(this.routes.deleteBillingCycle(billingCycleId, propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyBillsFileCabinet(data, options) {
    const propertyId = data.propertyId;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.propertyBillsFileCabinet(propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getFileAttached(data, options) {
    const billId = data.billId,
      fileId = data.fileId,
      isShared = data.isShared,
      redactedFileId = data.redactedFileId,
      sourceBillId = data.sourceBillId;
    const body = {
      billId,
      fileId,
      isShared
    };
    if (redactedFileId) {
      body.redactedFileId = redactedFileId;
    }
    if (sourceBillId) {
      body.sourceBillId = sourceBillId;
    }

    // Every caller that sends `fileId: null` means "take the document off", and a legacy bill has always
    // read it that way. A bill whose document lives in bill-automation reads a body with no file ids as a
    // share toggle instead, so its copies stayed put and a deleted redacted copy was left linked. Said by
    // name here, once, rather than at each of those callers (LB-5755). A share toggle sends no fileId at
    // all, so it is never mistaken for one.
    if (fileId === null && !redactedFileId) {
      body.detachFiles = true;
    }
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).patch(this.routes.fileAttached, _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSkippedCycles(data, options) {
    const propertyId = data.propertyId;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.skippedCycles(propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postCustomBillingCycle(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.customBillingCycle(data.propertyId), {
      allocationCycleId: data.allocationCycleId,
      utilityId: data.utilityId
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postTableApproval(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.approveTable, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postExcludeCorrection(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.excludeCorrection(data.correctionId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postIncludeCorrection(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.includeCorrection(data.correctionId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postReview(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.review, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createAllocationChargesBatch(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.submeterChargesBatch, {
      propertyId: data.propertyId,
      utilityId: data.utilityId,
      buildingId: data.buildingId,
      allocationCycleId: data.allocationCycleId,
      billingCycleId: data.billingCycleId,
      userInitialCsvFileId: data.userInitialCsvFileId,
      userEditedCsvFileId: data.userEditedCsvFileId,
      submeterCharges: [...data.submeterCharges]
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postGetSubMeterFinalState(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postGetSubMeterFinalState + "?".concat(Object.entries(data).map(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return "".concat(key, "=").concat(value);
    }).join('&')), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubMeterHistory(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubMeterHistory, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postGetSubmeterChargesFinalState(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postGetSubmeterChargesFinalState, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubmeterUnitMap(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.getSubmeterUnitMap, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async postSubmeterUnitMap(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterUnitMap, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubmeterCsvMaps(options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.getSubmeterCsvMaps, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubmeterCsvMap(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterCsvMap, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubmeterParseCsv(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterParseCsv, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubmeterBillingParseCsv(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterBillingParseCsv, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubmeterBillingAllocations(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.getSubmeterBillingAllocations, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: data
    }));
    return resp.data;
  }
  async postSubmeterBillingAllocationsSave(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterBillingAllocationsSave, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putSubmeterBillingAllocations(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).put(this.routes.putSubmeterBillingAllocations, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubmeterBillingAllocationsVariance(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.getSubmeterBillingAllocationsVariance, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: data
    }));
    return resp.data;
  }
  async getSubmeterBillingAllocationsUnmappedBillableUnits(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.getSubmeterBillingAllocationsUnmappedBillableUnits, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: data
    }));
    return resp.data;
  }
  async postSubmeterBillingAllocationsReview(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterBillingAllocationsReview, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubmeterBillingAllocationsApprove(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterBillingAllocationsApprove, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubmeterBillingAllocationsClear(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterBillingAllocationsClear, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubmeterBillingCsvMaps(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.getSubmeterBillingCsvMaps(data.propertyUtilityId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubmeterBillingCsvMap(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.getSubmeterBillingCsvMap(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubmeterBillingCsvMap(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterBillingCsvMap, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putSubmeterBillingCsvMap(data, options) {
    const id = data.id,
      body = _objectWithoutProperties(data, _excluded);
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).put(this.routes.putSubmeterBillingCsvMap(id), _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteSubmeterBillingCsvMap(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).delete(this.routes.deleteSubmeterBillingCsvMap(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubmeterBillingUnitMeterMaps(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).get(this.routes.getSubmeterBillingUnitMeterMaps(data.propertyUtilityId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubmeterBillingUnitMeterMapsByPropertyUtility(data, options) {
    const propertyUtilityId = data.propertyUtilityId,
      maps = data.maps;
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterBillingUnitMeterMapsByPropertyUtility(propertyUtilityId), {
      maps
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteSubmeterBillingUnitMeterMapsByPropertyUtility(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).delete(this.routes.deleteSubmeterBillingUnitMeterMapsByPropertyUtility(data.propertyUtilityId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSubmeterBillingUnitMeterMapsBatch(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.ALLOCATIONS).post(this.routes.postSubmeterBillingUnitMeterMapsBatch, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}